<template>
  <div>
    <draggable-fields
      v-if="configurationMode"
      :fields="fields"
      :visible-fields="visibleFields"
      resource-name="Entries"
      :tab="tab"
    />
    <fields
      v-else
      :fields="visibleFields"
      resource-name="Entries"
      :tab="tab"
      :transition="transition"
    />
    <hr v-if="hasEntryFields" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Fields from '../Fields/Fields';
import DraggableFields from '../Configuration/DraggableFields';

export default {
  components: {
    Fields,
    DraggableFields
  },
  props: {
    tab: {
      type: Object,
      required: true
    },
    transition: {
      type: String,
      default: 'push'
    }
  },
  computed: {
    ...mapGetters('entryForm', ['entryFields', 'visibleEntryFields']),
    ...mapState('entryFormConfiguration', ['configurationMode']),
    fields() {
      return this.entryFields(this.tab.id);
    },
    visibleFields() {
      return this.visibleEntryFields(this.tab.id);
    },
    hasEntryFields() {
      return (
        this.visibleFields.length ||
        (this.configurationMode && this.fields.length)
      );
    }
  }
};
</script>
